import { Field } from 'formik'

import { ButtonGroup } from 'ui'
import { t } from 'translations'

interface DayHourToggleProps {
  value: string
  index: number
  className?: string
  width?: number | string
}
export const DayHourToggle: React.FC<DayHourToggleProps> = ({ value, index, className, width }) => {
  return (
    <div className={className}>
      <ButtonGroup toggle style={{ width: width ?? 'inherit' }} role="group" aria-labelledby={`my-radio-group-${index}`}>
        <label className={`btn btn-${value === 'byDay' ? 'primary' : 'light'}`}>
          <Field type="radio" name={`assignBasedOnTheseRanges[${index}].type`} value="byDay" />
          {t('administration.wagePremiums.form.DAY')}
        </label>
        <label className={`btn btn-${value === 'byHour' ? 'primary' : 'light'}`}>
          <Field type="radio" name={`assignBasedOnTheseRanges[${index}].type`} value="byHour" />
          {t('administration.wagePremiums.form.HOUR')}
        </label>
      </ButtonGroup>
    </div>
  )
}
